<template>
  <div class="transactions">
    <div class="filter-wrapper">
     <div class="inputs-wrapper">
        <h3>Filter po</h3>
        <md-radio v-model="topFilter" :value="'performance'" v-if="isTicket">Izvedbi</md-radio>
        <md-radio v-model="topFilter" :value="'id'">Broju transakcije</md-radio>
        <md-radio v-model="topFilter" :value="'buyer'">Prezimenu</md-radio>
        <md-radio v-model="topFilter" :value="'date'">Datumu kreiranja</md-radio>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'id'">
        <h3>ID</h3>
        <md-field>
          <label>ID</label>
          <md-input v-model="id"/>
        </md-field>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'buyer'">
        <h3>Prezime</h3>
        <md-field>
          <label>Prezime</label>
          <md-input v-model="buyer"/>
        </md-field>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'date'">
        <h3>Datum</h3>
        <div class="date-wrapper">
          <md-datepicker v-model="start_date" md-immediately>
            <label>Od</label>
          </md-datepicker>
          <md-datepicker v-model="end_date" md-immediately>
            <label>Do</label>
          </md-datepicker>
        </div>
      </div>
      <div class="inputs-wrapper" v-if="topFilter == 'performance'">
        <h3>Izvedba</h3>
        <Autocomplete v-model="performanceID" :additionalField="'performance_date'" :stateObject="'performancesSimple'" :searchBy="'play_title'" :returnField="'id'" :label="'Odaberi izvedbu'"/>
      </div>
      <div class="inputs-wrapper with-button">
        <md-button class="md-raised md-dense md-primary" v-on:click="filterTransactions()">Prikaži</md-button>
        <md-button class="md-raised md-dense md-accent" :disabled="!searched" v-on:click="clear()">Poništi</md-button>
      </div>
    </div>
    <p class="error-message" style="color: red;text-align: center;font-weight: bold;">
      <span v-for="error in $store.state.errors">
        {{ error }}<br>
      </span>
    </p>
    <div v-if="$store.state.pageLoaded">
      <md-tabs md-alignment="centered" v-if="type == 'sales'">
        <md-tab md-label="Aktivne" v-on:click="filter = ['online_sold', 'partner_sold', 'offline_sold', 'theatre_manager', 'sponsor', 'employee']"/>
        <md-tab md-label="U čekanju" v-on:click="filter = ['online_checkout', 'offline_checkout']"/>
        <md-tab md-label="Rezervirane" v-on:click="filter = ['reservation']"/>
        <md-tab md-label="Stornirane" v-on:click="filter = ['cancelled']"/>
        <md-tab md-label="Nedovršene" v-on:click="filter = ['expired', 'aborted']"/>
        <md-tab v-if="isTicket" md-label="Ponude" v-on:click="filter = ['partner_checkout','partner_sold']"/>
        <md-tab md-label="Sve" v-on:click="filter = ['all']"/>
      </md-tabs>
      <div v-if="filteredTransactions.length > 0">
        <md-table v-model="filteredTransactions" md-sort="id" class="transactions-table table-align-top">
          <md-table-toolbar>
            <!--<md-field md-clearable class="md-toolbar-section-end search-field">
              <md-icon>search</md-icon>
              <md-input placeholder="Pretraži..." v-model="searchKey"/>
            </md-field>-->
          </md-table-toolbar>

          <md-table-toolbar>
            <div class="md-toolbar-section-start">
              <h1 class="md-title">{{ getTitle }}</h1>
            </div>
          </md-table-toolbar>

          <md-table-row md-selectable="single" slot="md-table-row" slot-scope="{ item }" md-auto-select>
            <md-table-cell md-label="ID" md-sort-by="id" md-numeric>{{ item.id }}</md-table-cell>
            <md-table-cell md-label="Predstava" md-sort-by="data.play_title" v-if="isTicket">
              <b>{{ item.data.play_title }}</b> - {{ new Date(item.data.performance_time).toLocaleDateString('hr-HR') }}
            </md-table-cell>
            <md-table-cell md-label="Pretplata" md-sort-by="data.subscription_number" v-else>
              {{ item.data.subscription_title }} <strong>{{ item.data.subscription_number }}</strong>
            </md-table-cell>
            <md-table-cell md-label="Kupac" class="capitalize" md-sort-by="data.employee.first_name" v-if="isTicket">
              <span v-if="item.data.hasOwnProperty('employee')">{{ item.data.employee.first_name }} {{ item.data.employee.last_name }}</span>
              <span v-else>{{ getHolder(item.data.buyer) }}</span>
            </md-table-cell>
            <md-table-cell class="capitalize" md-label="Nositelj" md-sort-by="data.subscribers.0.first_name" v-else>{{ getHolder(item.data.subscribers) }}</md-table-cell>
            <md-table-cell md-label="Napomena" class="capitalize" md-sort-by="data.note" v-if="isTicket">{{ item.data.note }}</md-table-cell>
            <md-table-cell md-label="Status" md-sort-by="status">
              <span v-html="getStatus(item.status, item.data.is_cancelled, item.data.cancelled_transaction_id)"/>
            </md-table-cell>
            <md-table-cell md-label="Datum plaćanja" v-if="type == 'sales'">{{ item.payment_date }}</md-table-cell>
            <md-table-cell md-label="Vrsta plaćanja" md-sort-by="payment_type" v-if="type == 'sales'" class="capitalize">{{ getPaymentType(item.payment_type) }}<span v-if="item.payment_type == 'card'">/{{ item.card_type }}</span></md-table-cell>
            <md-table-cell md-label="Broj rata" v-if="type == 'sales'">{{ item.installments }}</md-table-cell>
            <md-table-cell md-label="Cijena" md-sort-by="amount">{{ formatCurrency(item.amount , item.payment_date || item.created) }}</md-table-cell>
            <md-table-cell md-label="Popust">{{ formatCurrency((item.data.promo_code ? (item.amount / item.custom_discount - item.amount) : (item.custom_discount ? item.amount * item.custom_discount : 0)), item.payment_date || item.created) }}</md-table-cell>
            <md-table-cell md-label="Akcije">
              <md-button class="md-raised md-dense md-accent" :disabled="isCancelDisabled(item)" v-on:click="$store.state.currentTransaction = JSON.parse(JSON.stringify(item)); clickedItem = item; deleteDialog = true;">
                Storno
              </md-button>
              <md-button class="md-raised md-dense md-primary" :disabled="item.disabled" v-on:click="$store.state.currentTransaction = JSON.parse(JSON.stringify(item)); detailsVisible = true; window.document.body.style.overflow = 'hidden'; pageY = window.pageYOffset; window.scrollTo(0,0)">
                Detalji
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>

      <h3 v-if="filteredTransactions.length == 0" class="error">Nažalost nema ništa za prikaz</h3>
    </div>
    <md-dialog-confirm :md-active="deleteDialog"
                md-title="Storno transakcije"
                md-content="<div id=stornoConfirm class='md-field md-theme-default md-focused md-required'><label for='stornoInfo'>Razlog</label><textarea id='stornoInfo' class='md-input stornoInput'></textarea><br><span class='md-error'>Ovo polje je obavezno</span></div>Jeste li sigurni?"
                md-confirm-text="Potvrdi"
                md-cancel-text="Zatvori"
                v-on:md-confirm="cancelTransaction"
                v-on:md-cancel="deleteDialog=false"
                >
    </md-dialog-confirm>

    <TransactionDetails :fromPage="true" v-if="detailsVisible" @close="detailsVisible = false" class="details-page"/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import TransactionsMixin from '../../mixins/transactions-mixin';


export default {
  name: 'Transactions',

  mixins: [TransactionsMixin('sales')],

  data(){
    return{
      type: '',
      searched: '',
      id: '',
      window: null,
      end_date: new Date(),
      start_date: new Date(),
      buyer: '',
      performanceID: '',
      topFilter: 'id',
      searchKey: '',
      pageY: 0,
      deleteDialog: false,
      clickedItem: null,
      detailsVisible: false,
      stornoInfo: '',
    }
  },

  mounted(){
    this.window = window;
  },

  computed: {
    getTitle(){
      return this.type == 'sales' ? 'Transakcije' : 'Rezervacije'
    },

    isTicket(){
      return this.$store.state.isTicket && this.type == 'sales'
    },
  },

  methods:{
    async cancelTransaction(){
      this.stornoInfo = document.getElementById('stornoInfo').value;
      if(this.stornoInfo == ""){
        document.getElementById("stornoConfirm").classList.add('md-invalid');
        return;
      }
      this.deleteDialog = false;
      if(!['partner_sold', 'online_sold', 'offline_sold', 'gratis'].includes(this.$store.state.currentTransaction.status)){
        await this.$store.dispatch('cancelTransaction', {status: 'aborted', list: this.list});
      } else await this.$store.dispatch('cancelTransaction', {status: this.type == 'sales' ? 'cancelled' : 'aborted', list: this.list, stornoInfo: this.stornoInfo});
      this.clickedItem['disabled'] = true;
    },

    isCancelDisabled(item){
      return item.data.is_cancelled || item.status == 'aborted' || item.status == 'cancelled' || item.status == 'expired'
    },

    async filterTransactions(){
      this.$store.state.pageLoaded = false;
      this.searched = true;
      let filter = {}
      if(this.topFilter == 'id') filter['id'] = this.id;
      if(this.topFilter == 'buyer') filter['buyer'] = this.buyer;
      if(this.topFilter == 'performance') filter['performance'] = this.performanceID;
      if(this.topFilter == 'date') {
        if(this.end_date < this.start_date) filter['end_date'] = this.start_date.toLocaleDateString('hr-HR');
        else filter['end_date'] = this.end_date.toLocaleDateString('hr-HR');
        filter['start_date'] = this.start_date.toLocaleDateString('hr-HR');
      }
      await this.$store.dispatch('getTransactions', filter)

      this.filteredTransactions = this.getFilteredTransactions({searchKey: this.filter, list: this.$store.state.receivedData[this.list].list});
      this.$store.state.pageLoaded = true;

    },

    async clear(){
      this.$store.state.pageLoaded = false;
      await this.$store.dispatch('getTransactions');
      this.searched = false;
      this.filteredTransactions = this.getFilteredTransactions({searchKey: this.filter, list: this.$store.state.receivedData[this.list].list});
      this.$store.state.pageLoaded = true;
    }
  },

  watch:{
    '$store.state.pageLoaded'(){
      this.detailsVisible = false;
    },

    detailsVisible(value){
      if(!value){
        this.window.document.body.style.overflow = 'auto';
        this.window.scrollTo(0, this.pageY);
      }
    }
  }
}
</script>

<style lang="scss">
.transactions-table{
  .md-table-cell, .md-table-head{
    &:last-of-type{
      width: 255px;
      text-align: center;
    }
  }
}

.transactions{
  .error{
    font-size: 22px;
    margin: 100px 0 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }
}

.stornoInput{
  resize: none;
  height: 150px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Transactions.vue